"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var selectors_1 = require("../../../contexts/lootbox/selectors");
var constants_1 = require("../constants");
var ImageSequence_1 = __importDefault(require("./ImageSequence"));
var StartScreen = function (_a) {
    var framerate = _a.framerate, show = _a.show, onStart = _a.onStart;
    var miniGame = (0, selectors_1.useActiveLootBox)();
    var _b = (0, react_1.useState)(0), progress = _b[0], setProgress = _b[1];
    var animationInterval = (0, react_1.useRef)();
    var cancelAnimationInterval = (0, react_1.useRef)();
    var canStart = (0, react_1.useMemo)(function () { return Object.keys(miniGame).length > 0; }, [miniGame]);
    var startAnimation = function () {
        if (!canStart) {
            return;
        }
        clearInterval(cancelAnimationInterval.current);
        cancelAnimationInterval.current = undefined;
        if (animationInterval.current) {
            return;
        }
        var countDown = false;
        var minFrame = 53;
        var maxFrame = 63;
        animationInterval.current = setInterval(function () {
            setProgress(function (currentProgress) {
                if (currentProgress === minFrame) {
                    countDown = false;
                }
                if (currentProgress === maxFrame) {
                    countDown = true;
                }
                if (countDown) {
                    return currentProgress - 1;
                }
                if (currentProgress + 1 <= 100) {
                    return currentProgress + 1;
                }
                return currentProgress;
            });
        }, framerate);
    };
    var stopAnimation = function () {
        clearInterval(animationInterval.current);
        animationInterval.current = undefined;
        cancelAnimationInterval.current = setInterval(function () {
            setProgress(function (currentProgress) {
                if (currentProgress > 0) {
                    return currentProgress - 1;
                }
                if (currentProgress === 0) {
                    clearInterval(cancelAnimationInterval.current);
                }
                return currentProgress;
            });
        }, framerate);
    };
    var onMouseOver = function () {
        startAnimation();
    };
    var onMouseOut = function () {
        stopAnimation();
    };
    if (!show) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--title" }, { children: "Deschide cadoul \u0219i s\u0103 \u00EEnceap\u0103 distrac\u021Bia!" })), (0, jsx_runtime_1.jsxs)(ImageSequence_1.default, __assign({ onClick: onStart, onMouseLeave: onMouseOut, onMouseEnter: onMouseOver, progress: progress, sequence: constants_1.idleSequence }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ disabled: !canStart, type: "button", className: "main-button" }, { children: "Apas\u0103 aici" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "lootbox--sequence-hint" }, { children: "Deschide cadoul prin ap\u0103sarea ecranului \u0219i prime\u0219ti cadouri supriz\u0103." }))] }))] }));
};
exports.default = StartScreen;
